import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class WhatsGrpDTO {
    @ApiProperty()
    @IsOptional()
    Id?: number;
    @ApiProperty()
    groupId:string;
    @ApiProperty()
    groupName:string;
    @ApiProperty()
    @ApiProperty()
    status: number;
    createdAt : Date;
    @ApiProperty()
    @IsOptional()
    createdUser : number;
    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    updatedUser : number;
    @ApiProperty()
    @IsOptional()
    versionFlag : number;
}

export class GrpStatuUpdateDto {
    @ApiProperty()
    Id: number;
    @ApiProperty()
    status: number;
    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    updatedUser : number;
    @ApiProperty()
    @IsOptional()
    versionFlag : number;
}


export class WhatsAppSetngDto {
    @ApiProperty()
    Id: number;
    @ApiProperty()
    status: number;
}

export class MsgDTO {
    @ApiProperty()
    @ApiPropertyOptional()
    Id?: number;
    @ApiProperty() 
    @ApiPropertyOptional()
    mobileno:string;
    @ApiProperty() 
    @ApiPropertyOptional()
    mobilenums:string; 
    @ApiProperty() 
    @ApiPropertyOptional()
    text:string;   
    @ApiProperty()
    @IsNotEmpty({message:"Type should not be empty"})
    TypeId:number;
    @ApiProperty()
    @ApiPropertyOptional()
    userId: number;    
    @ApiProperty()
    @ApiPropertyOptional()
    versionFlag : number;
    @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } })
    @ApiPropertyOptional()
    attachments?: any[];    
}
  